/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "4004d981ee03625d3603dc0038b488366ca8fe26";
